import { Box } from '@mui/material';

export function DrawerHandle({ closeDrawer }: { closeDrawer: () => void }) {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: '10px' }}>
            <Box
                width='50px'
                sx={{ background: 'lightgray', borderRadius: '3px', height: '5px', cursor: 'pointer' }}
                onClick={closeDrawer}
            />
        </Box>
    );
}
